import {memo} from 'react';
import {Card, CardBody, Typography} from "@material-tailwind/react";
import PieChart, {PieChartProps} from "./PieChart";
import TitleWithInfoTooltip from "../TitleWithInfoTooltip";

interface DashboardChartProps {
    title: string,
    data: PieChartProps,
    tooltip?: string,
}

interface DashboardChartsProps {
    elements: DashboardChartProps[],
}

const DashboardCharts = ({elements}: DashboardChartsProps) => {

    return (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-12 mb-4">
            {elements.map((e) => {
                return <Card key={e.title} className="bg-white dark:bg-blue-gray-900 dark:text-gray-500 mb-8">
                    <CardBody className="w-full px-2 block h-96" id='successful_deposits'>
                        <Typography variant="h6" className="mb-6 text-center">
                            <TitleWithInfoTooltip title={e.title} tooltip={e.tooltip} className="justify-center"/>
                        </Typography>
                        <PieChart
                            isLoading={e.data.isLoading}
                            labels={e.data.labels}
                            series={e.data.series}/>
                    </CardBody>
                </Card>
            })}
        </div>
    );
}

export default memo(DashboardCharts);
